import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import AppNavbar from "../../../components/common/AppNavbar";

const SingaporeImmigration2026 = () => {
  return (
    <>
      <AppNavbar />
      <div style={{ background: "#f4f7fb" }}>
        {/* HERO SECTION */}
        <div
          style={{
            background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="light" text="dark" className="mb-3">
              Singapore Immigration 2026
            </Badge>
            <h1 className="fw-bold">
              No-Boarding Directive Brings Stricter Pre-Departure Checks
            </h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              From January 30, 2026, Singapore introduces airline-enforced entry
              screening — shifting immigration control to the point of departure
              for Indian/Bharat travelers.
            </p>
          </Container>
        </div>

        <section class="immigration-article">
          <div class="container py-5">
            <h2>
              Singapore Immigration Reforms 2026: No-Boarding Directive &
              Digital Border Enforcement
            </h2>

            <p>
              Beginning <strong>January 30, 2026</strong>, the Immigration &
              Checkpoints Authority (ICA) will enforce a new
              <strong>No-Boarding Directive (NBD)</strong> allowing airlines to
              deny boarding at the departure airport to passengers who do not
              meet Singapore’s entry requirements.
            </p>

            <p>
              The measure is designed to stop inadmissible travelers before
              takeoff, reducing on-arrival refusals and strengthening national
              security.
            </p>

            <hr />

            <h3>No-Boarding Directive (NBD): Airlines Must Deny Boarding</h3>

            <p>
              Under the NBD, airlines will receive digital notifications from
              ICA identifying travelers who must not be allowed to board.
            </p>

            <p>
              <strong>This includes passengers with:</strong>
            </p>

            <ul>
              <li>Invalid visas</li>
              <li>Expired passports</li>
              <li>Insufficient passport validity (less than 6 months)</li>
              <li>Security or immigration flags</li>
            </ul>

            <p>
              Airlines that fail to comply may face fines of up to{" "}
              <strong>SGD 10,000</strong>. Airline staff, including pilots and
              ground crew, may also face penalties or imprisonment.
            </p>

            <p>
              Passengers denied boarding must now obtain{" "}
              <strong>written approval from ICA</strong> before rebooking travel
              to Singapore.
            </p>

            <hr />

            <h3>
              Stricter Pre-Departure Screening for Indian/Bharat Nationals
            </h3>

            <p>
              For Indian/Bharat travelers, the 2026 changes introduce
              significantly stricter pre-departure checks.
            </p>

            <p>
              <strong>Airlines must verify:</strong>
            </p>

            <ul>
              <li>Visa validity</li>
              <li>Passport validity (minimum 6 months)</li>
              <li>Submission of the SG Arrival Card (SGAC)</li>
              <li>Security, immigration, or document alerts flagged by ICA</li>
            </ul>

            <p>
              Singapore’s system integrates SG Arrival Card data, flight
              manifests, and advance passenger information to pre-screen
              travelers before departure.
            </p>

            <p>
              Indian/Bharat travelers must ensure all documents are accurate,
              updated, and compliant to avoid denial of boarding at the airport.
            </p>

            <hr />

            <h3>
              Enhanced Digitalization & Security Under the Immigration
              (Amendment) Bill
            </h3>

            <p>
              The NBD rollout complements Singapore’s broader Immigration
              (Amendment) Bill reforms, enabling:
            </p>

            <ul>
              <li>Expanded use of digital permits and passes</li>
              <li>Strengthened data security frameworks</li>
              <li>Greater automation in immigration processing</li>
            </ul>

            <p>
              These upgrades streamline entry procedures, reduce identity fraud,
              and enhance verification capabilities, forming the foundation of
              Singapore’s 2026 digital immigration ecosystem.
            </p>

            <hr />

            <h3>Work Visa Landscape: Strict Salary Thresholds Continue</h3>

            <p>
              For foreign professionals, including many Indian/Bharat nationals,
              Singapore maintains strict Employment Pass (EP) salary thresholds
              aligned with market benchmarks.
            </p>

            <p>
              Throughout 2026, EP renewals and new applications remain subject
              to wage criteria intended to safeguard the local labor market.
              While the thresholds are not new, enforcement and scrutiny are
              expected to intensify under the digitized system.
            </p>

            <hr />

            <h3>Health Advisory Precautions for Travelers from India/Bharat</h3>

            <p>
              Singaporean authorities advise travelers from regions with ongoing
              health concerns, such as localized Nipah virus outbreaks in parts
              of India, to monitor official advisories before travel.
            </p>

            <p>
              Airlines may apply additional caution for passengers arriving from
              affected regions.
            </p>

            <hr />

            <h3>Summary</h3>

            <p>
              Singapore’s 2026 immigration reforms mark a decisive shift toward
              preventive, data-driven, and digitally enhanced border management.
            </p>

            <p>
              For Indian/Bharat nationals — who represent a significant share of
              business and leisure travelers — the impact is immediate:
            </p>

            <ul>
              <li>Stricter documentation checks</li>
              <li>Higher compliance expectations</li>
              <li>Real risk of boarding denial if requirements are unmet</li>
            </ul>

            <p>
              Travelers must prioritize document accuracy, visa compliance, and
              advance preparation to avoid disruptions under the new No-Boarding
              Directive regime.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default SingaporeImmigration2026;
